import { CurrencyContext } from '@c/CurrencyContext';
import { getJSFormattedCurrency } from '@h/currency';
import React, { useMemo } from 'react';
import { DeliveryMethod } from './DeliveryMethod';
import { useTranslation } from '@c/Translations';
import { DeliveryDescription } from './DeliveryDescription';

export const DeliveryOptionsSelect = (props) => {
  const { deliveryOptions, selectedOption, onDeliveryChange, disabled, isKioskMode, ...rest } = props;

  const { t } = useTranslation();

  const onDeliveryOptionSelect = (e) => {
    const id = Number(e.target.value);
    onDeliveryChange(deliveryOptions.find((option) => option.id === id));
  };

  const deliveryOption = useMemo(() => {
    return deliveryOptions.find((option) => option.id === selectedOption) || {};
  }, [deliveryOptions, selectedOption]);

  const getOptionLabel = (option, config) => {
    const name = option.id === 2 ? t('checkout__email') : option.name;

    return `${name} - ${getJSFormattedCurrency(option.price.amount, config)}`;
  }

  return (
    <div className="delivery__option-select">
      <CurrencyContext.Consumer>
        {(config) => {
          return (
            <div className="input__select">
              <select
                className="input__control"
                value={selectedOption}
                onChange={onDeliveryOptionSelect}
                disabled={disabled}
              >
                {deliveryOptions.map((option) => (
                  <option key={option.id} value={option.id}>
                    {getOptionLabel(option, config)}
                  </option>
                ))}
              </select>
            </div>
          );
        }}
      </CurrencyContext.Consumer>
      <DeliveryDescription
        deliveryOption={deliveryOption}
        isKioskMode={isKioskMode}
      />
      <DeliveryMethod
        {...rest}
        isKioskMode={isKioskMode}
        deliveryOption={deliveryOption}
        selected={!!selectedOption}
      />
    </div>
  );
};
